// extracted by mini-css-extract-plugin
module.exports = {"input":"index-shimmer_input__2kzIe","placeholderShimmer":"index-shimmer_placeholderShimmer__3z9UH"};